var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_setup.voucherTitle))]),_vm._l((_setup.voucherItem),function(item,index){return _c('td',{key:index},[_c('span',{class:_setup.tdClass(item),domProps:{"innerHTML":_vm._s(_setup.tdText(item))}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }